import React from 'react'
import { createRoot } from 'react-dom'
import App from './src/app.js'
import {ready} from '~/utils'

ready(() => {
  const el = document.querySelector('[data-leadform]')
  const form = JSON.parse(el.dataset.leadform || '{}')
  const root = createRoot(el)
  root.render(<App form={{...form}} />)
});
